export default Object.freeze({
  // TIME_LOG_DELETE: 'TIME_LOG_DELETE',
});
